var $ = require('jquery'),
	$w = $(window);
	
var YouTube = function () {

	var APILoaded = false,
		scriptIncluded = false,
		queuedArgs = [];
	
	window.onYouTubeIframeAPIReady = function() {
		APILoaded = true;
		queuedArgs.forEach(function(args){
			this.createPlayer.apply(this, args)
		}.bind(this));
		queuedArgs = [];
	}.bind(this);
	
	function includeScript(){
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	};

	this.testURL = function( href )
	{
		var a = document.createElement("a");
		a.href = href;
		
		return ['youtube.com', 'youtu.be', 'www.youtube.com'].indexOf(a.hostname) > -1;
	};

	this.extractVideoId = function( url )
	{
		return url.match(
			/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
		)[1];	
	};
	
	this.createPlayer = function( $container, startPaused ){
	
		if ( !APILoaded ) {
			queuedArgs.push(arguments);
			!scriptIncluded && includeScript();
			return; 
		}
		
		var playing = false,
			videoId = this.extractVideoId($container.data('video-url')),
			$dummy = $('<div></div>'); // yt *replaces* given element with its iframe
			
		$container.append($dummy);
			
		return new YT.Player($dummy[0], {
			height: '100%',
			width: '100%',
			videoId: videoId,			
			events: {
				'onReady': function( e ){
					if( !startPaused )
						e.target.playVideo();
				},
				'onStateChange': function( event ){
		
					if(event.data == YT.PlayerState.PLAYING && !playing) {
		
						playing = true;
						$w.trigger('gc.video', ['play', 'yt/'+videoId, player.getCurrentTime()]);
		
					} else if(playing && [YT.PlayerState.PAUSED, YT.PlayerState.ENDED].indexOf(event.data) > -1) {
		
						playing = false;
						$w.trigger('gc.video', ['pause', 'yt/'+videoId, player.getCurrentTime()]);
		
					}
		
					if(event.data == YT.PlayerState.ENDED) {
		
						playing = false;
						$w.trigger('gc.video', ['end', 'yt/'+videoId]);
		
					}
				}
			}
		});
	}.bind(this);
};

var VimeoClass = function(){
	
	this.testURL = function( href )
	{
		var a = document.createElement("a");
		a.href = href;
		
		return ['vimeo.com', 'www.vimeo.com'].indexOf(a.hostname) > -1;
	};
	
	this.extractVideoId = function( url )
	{
		return url.split('/').pop();
	};
	
	this.createPlayer = function( $container, startPaused ){
	  
	  var videoId = this.extractVideoId( $container.data('video-url') );
	  
	  $.getScript('https://player.vimeo.com/api/player.js', function () {
	    
	    	var $iframe = $('<iframe src="https://player.vimeo.com/video/'+videoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay; fullscreen"></iframe>');
	    	
	    	if(!startPaused)
	    		$iframe.attr('data-vimeo-autoplay', true);
	    	
	    	$container.append($iframe);
	    
	        var player = new Vimeo.Player($iframe[0], {
	        	autoplay: !startPaused
	        });
	
	        player.on('play', function() {
	        	$w.trigger('gc.video', ['play', 'vm/'+videoId, player.getCurrentTime()]);
	        });

	        player.on('pause', function() {
	        	$w.trigger('gc.video', ['pause', 'vm/'+videoId, player.getCurrentTime()]);
	        });

	        player.on('ended', function() {
	        	$w.trigger('gc.video', ['end', 'vm/'+videoId]);
	        });
	        
	        !startPaused && setTimeout(function(){
	        	player.play();
	        }, 1500);
	    });	
	  
	}.bind(this);
};

var VideoSources = {
	YouTube: new YouTube(),
	Vimeo: new VimeoClass()
};

module.exports = {
	createPlayer: function( $container, startPaused )
	{
		var url = $container.data('video-url');
		
		for(var name in VideoSources)
			if(VideoSources[name].testURL(url))
				VideoSources[name].createPlayer( $container, startPaused );
	}
};


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/video.js
// module id = 8
// module chunks = 0